import { Reducer } from 'redux';
import _ from 'lodash';
import {
	AdviserAction,
	AdviserDetailsActionTypes,
	EmulationAdviserDetailsActionTypes,
} from '../../actions/adviser.actions';
import { Identity } from '../../../logic/domains/identity.domain';
import { EmulatedAdviser } from '../../../logic/domains/emulatedAdviser.domain';
import { IdentityInfo } from '../../../logic/domains/identityInformation.domain';
import { AdviserState } from '../../../type-definitions/redux-declarations';

const initialState: AdviserState = {
	adviserDetails: {
		customerToken: '',
		customerNumber: '',
		lastLoggedin: '',
		firstName: '',
		lastName: '',
		roles: [],
	},
	error: false,
	loading: true,
	isAuthorised: true,
};

const reducer: Reducer<AdviserState, AdviserAction> = (
	state = initialState,
	action: AdviserAction
): AdviserState => {
	switch (action.type) {
		case AdviserDetailsActionTypes.ADVISER_GET_DETAILS_SUCCESS: {
			const adviserDetailsResp = action.response as Identity;
			if (!adviserDetailsResp) {
				return {
					...state,
					adviserDetails: adviserDetailsResp,
					loading: false,
				};
			}
			const roles =
				adviserDetailsResp &&
				_.map(adviserDetailsResp.roles, (item: any) => item.roleName);
			return {
				...state,
				adviserDetails: {
					customerNumber: adviserDetailsResp.principal,
					customerToken: adviserDetailsResp.principalToken,
					firstName: adviserDetailsResp.firstName,
					lastName: adviserDetailsResp.lastName,
					lastLoggedin: adviserDetailsResp.lastLoggedin,
					roles,
				},
				error: false,
				loading: false,
			};
		}
		case EmulationAdviserDetailsActionTypes.EMULATED_GET_OFFICE_USER_AND_ADVISER_DETAILS_SUCCESS: {
			let adviserResp = action.adviserDetails as Identity;
			const emulatedAdviserDetails = action.officeUserEmulatedAdviserDetails as EmulatedAdviser;
			const emulationToken = action.emulationToken as string;

			// Copy customer token and set the adviser company name and organisation name
			let adviserDetails: IdentityInfo = {
				firstName: adviserResp.firstName,
				lastName: adviserResp.lastName,
				lastLoggedin: adviserResp.lastLoggedin,
				roles: [...adviserResp.roles, ...(emulatedAdviserDetails.roles || [])],
				adviserCompanyName:
					emulatedAdviserDetails.companyName === undefined
						? ''
						: emulatedAdviserDetails.companyName,
				adviserFirstName:
					emulatedAdviserDetails.firstName === undefined
						? ''
						: emulatedAdviserDetails.firstName,
				adviserLastName:
					emulatedAdviserDetails.lastName === undefined
						? ''
						: emulatedAdviserDetails.lastName,
				customerToken:
					emulationToken === undefined
						? emulatedAdviserDetails.customerToken
						: emulationToken.replace('#/', ''),
				customerNumber: emulatedAdviserDetails.customerNumber,
				isOfficeUserEmulation: true,
				csrUserId: adviserResp.principal,
			};

			if (!adviserDetails) {
				return {
					...state,
					adviserDetails,
					loading: false,
				};
			}
			const roles =
				adviserDetails &&
				_.map(adviserDetails.roles, (item: any) => item.roleName);
			return {
				...state,
				adviserDetails: {
					...adviserDetails,
					roles,
				},
				error: false,
				loading: false,
			};
		}

		case AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE: {
			return {
				...state,
				adviserDetails: { ...initialState.adviserDetails },
				error: true,
				loading: false,
			};
		}
		case AdviserDetailsActionTypes.ADVISER_GET_DETAILS_LOADING: {
			return {
				...state,
				loading: true,
			};
		}
		case AdviserDetailsActionTypes.ADVISER_GET_DETAILS_NOT_AUTHORISED: {
			return {
				...state,
				isAuthorised: false,
			};
		}
		default: {
			return state;
		}
	}
};

export { initialState, reducer as adviserReducer };
